
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PhotoRelation, PhotoSize } from '@app/core/constants/global-enum';
import { IRequestData } from '@app/core/interfaces/request-data.interface';
import { DataService } from '@app/core/services/data.service';
import { SubSink } from '@app/core/subsink';
import { finalize } from 'rxjs';
import { ITagDetails } from './interfaces/tag-details.interface';

@Component({
    selector: 'app-tag-item-property-tag-details',
    templateUrl: './tag-item-property-tag-details.component.html',
    styleUrls: ['./tag-item-property-tag-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagItemPropertyTagDetailsComponent implements OnInit, OnDestroy {

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    public isRequesting = false;
    public itemTotal: number = 0;
    public title: string = '';

    public dataSource = new MatTableDataSource<ITagDetails>();
    public displayedColumns: string[] = ['photoUrl', 'tagType', 'group', 'priority', 'trackingItemDescription', 'createdAt'];

    private record: any = [];
    private recordId: string;

    private subs = new SubSink();

    constructor(
        public dialogRef: MatDialogRef<TagItemPropertyTagDetailsComponent>, @Inject(MAT_DIALOG_DATA) data: any,
        private dataService: DataService,) {

        this.record = data.item;
        this.recordId = this.record.tagId;
        this.title = `${this.record.tagCode} - ${this.record.tagName}`;

    }

    ngOnInit(): void {
        this.loadData();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    public onClose(): void {
        this.dialogRef.close();
    }

    public getPhotoLink(photoId: string, size: PhotoSize = PhotoSize.Medium): string {
        return this.dataService.photoLink(photoId, PhotoRelation.Tag, size);
    }

    public errorHandler(event: any): any {
        event.target.src = './assets/images/placeholders/placeholder-small.png';
    }

    public loadData(): void {

        this.isRequesting = true;

        this.subs.add(
            this.dataService
                .getAny(`tag/get-tag-with-details-by-id/${this.recordId}`)
                .pipe(
                    finalize(() => {
                        this.isRequesting = false;
                    })
                )
                .subscribe((response: IRequestData) => {

                    console.log('response', response);

                    this.itemTotal = response.totalCount;

                    this.dataSource = new MatTableDataSource<ITagDetails>(response.data);
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;

                }, (error: HttpErrorResponse) => {
                    console.log('error', error);
                })
        );
    }

}
